import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";
import { StoreModelNames } from "../../dali/type/dali.type";
import { WizardStoreModel } from "../../../models/store/wizard.store.model";
import { signal } from "@angular/core";
import { WizardView } from "@bitwarden/web-vault/app/models/view/wizard/wizard.view";
import { tasks } from "@vault/web-vault/app/services/guideWizard/guide-wizard.service";

export const WizardType = {
  account: "account",
  guide: "guide",
};

export class WizardStoreCollection extends StoreModelCollection {
  readonly type: StoreModelNames = "WizardStoreModel";

  protected models: Map<string, WizardStoreModel> = new Map<string, WizardStoreModel>();

  private _wizardViews = signal<WizardView[]>(null);
  readonly wizardViews = this._wizardViews.asReadonly();

  triggerChanges(): void {
    const views: WizardView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(new WizardView(model)));
    });

    this._wizardViews.set(views);
  }

  getDefaultAccountCreationWizard(): WizardView {
    const AccountWizard = new WizardView();
    AccountWizard.step = { isComplete: false, stepIndex: 1 };
    AccountWizard.type = WizardType.account;
    return AccountWizard;
  }

  getDefaultGuideWizard(): WizardView[] {
    if (this.findWizardByType(WizardType.guide)) {
      return;
    }
    const GuideWizards: WizardView[] = [];
    for (const { id } of tasks) {
      const GuideWizard = new WizardView();
      GuideWizard.type = WizardType.guide;
      GuideWizard.step = { isComplete: false, stepIndex: id };
      GuideWizards.push(GuideWizard);
    }
    return GuideWizards;
  }

  findWizardsByType(type: string): WizardView[] {
    return this.wizardViews()?.filter((wizard) => wizard.type === type);
  }

  findWizardByType(type: string): WizardView {
    return this.wizardViews()?.find((wizard) => wizard.type === type);
  }

  clear(): void {
    const guideWizards = this.findWizardsByType(WizardType.guide);
    this.models.clear();
    this._wizardViews.set(guideWizards);
  }
}
